import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "banner clearfix" }
const _hoisted_2 = { class: "cont clearfix" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "mainbox clearfix" }
const _hoisted_5 = { class: "pruinfo" }
const _hoisted_6 = { class: "carouse" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "usages" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "cores" }
const _hoisted_12 = { class: "mainbox" }
const _hoisted_13 = { class: "cont" }
const _hoisted_14 = { class: "imags" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 0,
  class: "asideNav"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "tex" }

import { ref, reactive, onMounted, watch } from "vue";
import Nav from "@/components/nav/Index.vue";

import { getProductInfo } from "@/api/backstage";
import { useRouter, useRoute } from "vue-router";
import { getProduct } from "@/api/index";
import p1 from "@/assets/website/p1.png";
import p2 from "@/assets/website/p2.png";
import p3 from "@/assets/website/p3.png";
import p4 from "@/assets/website/p4.png";
import p5 from "@/assets/website/p5.png";


export default /*@__PURE__*/_defineComponent({
  __name: 'Details',
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const imgs = [p1, p2, p3, p4, p5];
const router = useRouter();
const route = useRoute();
const data = ref("");
const acrRef = ref(null);
const showSider = ref(false);
const props = __props;

const dataMap = reactive({
   pic:"",
   products:'',
});

const mb =ref('');
 watch(
  () => props.isMobile,
  (newv, oldv) => {
       props.isMobile? mb.value = true : mb.value = false;    
  }
);

const getData = (id) => {
  getProductInfo(id).then((res: any) => {
    for (const item of res.data.albums) {
      if (item.fileName)
        item.fileurl = localStorage.getItem("fileUrel") + item.fileName;
    }
    for (const item of res.data.usages) {
      if (item.fileName)
        item.fileurl = localStorage.getItem("fileUrel") + item.fileName;
    }
    for (let i = 0; i < res.data.cores.length; i++) {
      res.data.cores[i].img = imgs[i];
    }
    data.value = res.data;
    dataMap.pic = res.data.albums;
    setTimeout(()=>{
      acrRef.value?.setActiveItem(0);
      },100);
    });
};

const getAllItem = () =>{
  getProduct().then((res: any) =>{
    dataMap.products = res.data[route.query.t];
  });
};

const handleScroll = (e) => {
   if(e.target.scrollingElement.scrollTop>200){
      showSider.value = true;
   } else {
     showSider.value = false;
   }
};


onMounted(() => {
  getData(route.query.id);
  getAllItem();
  mb.value =props.isMobile;
  window.addEventListener("scroll", handleScroll, true); 
});

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(mb.value?'Mobile':'pc')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Nav, {
        style: 'w',
        isMobile: mb.value
      }, null, 8, ["isMobile"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, _toDisplayString(data.value.title), 1),
        (!mb.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(data.value.description), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_carousel, {
            ref_key: "acrRef",
            ref: acrRef
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataMap.pic, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: item.fileurl,
                      alt: ""
                    }, null, 8, _hoisted_7)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 512)
        ])
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "运用场景", -1)),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.usages, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: index
          }, [
            _createElementVNode("img", {
              src: item.fileurl,
              alt: "",
              style: _normalizeStyle({width:mb.value?'':item.width/100+'rem'})
            }, null, 12, _hoisted_9),
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.useName), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", null, "核心优势", -1)),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.cores, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item", index%2==1?'light':'blue']),
              key: index
            }, [
              _createElementVNode("div", _hoisted_14, [
                (!mb.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: item.img,
                      alt: ""
                    }, null, 8, _hoisted_15))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("h3", null, _toDisplayString(item.title), 1),
              _createElementVNode("p", null, _toDisplayString(item.description), 1)
            ], 2))
          }), 128))
        ])
      ])
    ]),
    (showSider.value&&!mb.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataMap.products, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass({select:item.id==data.value.id}),
                key: index,
                onClick: ($event: any) => (getData(item.id))
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "line" }, null, -1)),
                _createElementVNode("div", _hoisted_18, _toDisplayString(item.title), 1)
              ], 10, _hoisted_17))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})